import { StyleSheet, Platform, Dimensions } from 'react-native'
import Color from 'color'
import * as colors from '../../config/colors'
import * as v from '../../config/variables'

const { height, width } = Dimensions.get('window')

const sliderWidth = width

const styles = StyleSheet.create({
  container: {
    // padding: v.SPACE_SM,
    // paddingBottom: 110,
    // marginVertical: v.SPACE_SM,
    backgroundColor: colors.grayDark,
    // borderRadius: v.BORDER_RADIUS_SMALL
  },
  sliderWrapper: {
    // height: 300,
  },
  slide: {
    // width: sliderWidth,
    padding: v.SPACE_SM,
    justifyContent: 'center',
    // paddingBottom: 0
  },
  dotStyle: {
    // backgroundColor: Color(colors.white).alpha(0.3),
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
  },
  dotActiveStyle: {
    backgroundColor: colors.white,
    // marginHorizontal: 0
  },
  sliderImageContainer: {
    // resizeMode: 'contain',
    // width: '100%',
    height: width < 500 ? 350 : 500,
  },
  sliderImage: {
    // flex: 1,
    // resizeMode: 'contain'
    // height: undefined, width: undefined
  },
  descriptionContainer: {
    marginTop: v.SPACE_SM,
  },
  description: {
    color: colors.white,
    fontSize: v.FONT_SIZE_SMALL,
    lineHeight: 15,
    // maxHeight: 100
  },
  title: {
    fontWeight: 'bold',
    fontFamily: v.FONT_FAMILY_BOLD,
  },
  subtitle: {
    // borderWidth: 1,
    // top: 50,
    // left: 0,
    // width: '100%'
  },
  pagination: {
    paddingVertical: v.SPACE_MD,
  },
  buttonContainer: {
    // height: '100%',
    // width: '7%',
    // alignItems: 'center',
    padding: 4,
    justifyContent: 'center',
    backgroundColor: 'transparent',
    position: 'absolute',
    top: '40%',
    zIndex: 1,
  },
  buttonContainerLeft: {
    left: -10,
  },
  buttonContainerRight: {
    right: -10,
  },
  button: {
    // position: 'absolute',
    // zIndex: 1,
  },
  buttonNext: {
    // fontSize: 50,
    // borderWidth: 2,
    color: colors.white,
  },
  buttonPrev: {
    // fontSize: 50,
    color: colors.white,
  },
})

export default styles
